import React from 'react';
import { Inbox } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
import { supabaseConfig } from '../../data/supabaseConfig';
export function NoEventsYet() {
  return <Card className="mt-4" data-id="element-263" data-mp="ybfwfmjbjjko">
      <CardHeader data-id="element-264" data-mp="ycr2xu45f5fh">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-secondary-foreground" data-id="element-265" data-mp="tjxyl7cldz3x">
          <Inbox className="h-4 w-4" aria-hidden="true" data-id="element-266" data-mp="188c79ywowhse" />
        </span>
        <CardTitle className="mt-3" data-id="element-267" data-mp="18aolc0zbu806">Connected — no events yet</CardTitle>
        <CardDescription data-id="element-268" data-mp="139hh2bwe7qy9">
          Supabase is reachable, but no maintenance-page events have been recorded for{' '}
          {supabaseConfig.monitoredHost} in the last {supabaseConfig.lookbackMinutes / 60} hours.
        </CardDescription>
      </CardHeader>
      <CardContent data-id="element-269" data-mp="3j03oixtn8uft">
        <ul className="list-disc space-y-1.5 pl-5 text-sm text-muted-foreground" data-id="element-270" data-mp="3j1ok8qrp2jf9">
          <li data-id="element-271" data-mp="3e2lknluhh5eo">Open the public maintenance page once — every view writes a row.</li>
          <li data-id="element-272" data-mp="smp9ddoobqkn">
            Press “Check again” and the support email link to generate retry and support events.
          </li>
          <li data-id="element-273" data-mp="xm1vtxbmuvmp">Then refresh this dashboard; data appears within a minute.</li>
        </ul>
      </CardContent>
    </Card>;
}